import { StrapiUploadFile } from 'graphqlTypes';

export const getImageData = (strapiImageData: StrapiUploadFile) => {
  const {
    file: {
      childImageSharp: { gatsbyImageData },
    },
    alternativeText,
    url,
  } = strapiImageData;
  if (gatsbyImageData) {
    // generate props for pictures source
    const { height, width, images, placeholder } = gatsbyImageData;
    if (images) {
      return {
        alt: alternativeText,
        height,
        width,
        sourceProps: images,
        placeholder,
        imgProps: {
          src: url,
        },
      };
    }
    return {
      alt: alternativeText,
      height,
      width,
      sourceProps: null,
      placeholder,
      imgProps: {
        src: url,
      },
    };
  }
  return {
    alt: alternativeText,
    sourceProps: null,
    height: undefined,
    width: undefined,
    placeholder: null,
    imgProps: {
      src: url,
    },
  };
};
